<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <CIcon name="cil-user"/>
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownItem @click="logout()">
      <CIcon name="cil-lock-locked"/> Выйти
    </CDropdownItem>
  </CDropdown>
</template>

<style>
  .c-avatar .c-icon {
    width: 30px;
    height: 30px;
  }
</style>

<script>
export default {
  name: 'TheProfileHeaderDropdownAccnt',
  data () {
    return { 
      itemsCount: 42
    }
  },
  methods: {
    logout() {
      this.$authService.logout();
      this.$router.push('/login');
    },
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
